import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import gameActions from 'redux/actions/gameActions'
import bindActionsToDispatch from 'helpers/bindActionsToDispatch'
import pickerSelector from 'redux/selectors/picker/picker_selector'

import Picker from 'views/picker/main_picker/picker'

class GameQuestionImagePicker extends PureComponent {

	constructor(props) {
		super(props)
	}

	onFilePicked = (file, acceptedFiles) => {
		this.props.actions.filePicked(acceptedFiles, file, this.props.questionId, false)
	}

	onFileError = message => {
		this.props.actions.fileError(message, this.props.questionId)
	}

	render() {
		return (
			<Picker
				onFilesPicked={this.onFilePicked}
				onFileError={this.onFileError}
				closeHandler={this.props.actions.closeModal}
				pickerType={this.props.pickerType}
				googleDrivePickerOrigin={this.props.googleDrivePickerOrigin}
			/>
		)
	}
}

GameQuestionImagePicker.propTypes = {
	googleDrivePickerOrigin: PropTypes.string,
	modalName: PropTypes.string,
	questionId: PropTypes.string,
	pickerType: PropTypes.string,
	actions: PropTypes.shape({
		closeModal: PropTypes.func.isRequired,
		filePicked: PropTypes.func.isRequired,
		fileError: PropTypes.func.isRequired,
	}),
}

function mapStateToProps(state) {
	return pickerSelector(state)
}

function mapDispatchToProps(dispatch) {
	return bindActionsToDispatch({
		closeModal: gameActions.questionMediaPickerCancelled,
		filePicked: gameActions.questionMediaPickerSelected,
		fileError: gameActions.questionMediaPickerError,
	}, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(GameQuestionImagePicker)

export { GameQuestionImagePicker }
